import { useState, useEffect } from "react";
import toastError from "../../errors/toastError";
import { format, sub } from 'date-fns'
import api from "../../services/api";

const useTickets = ({
  searchParam,
  tags,
  users,
  pageNumber,
  status,
  date,
  dateStart,
  dateEnd,
  updatedAt,
  showAll,
  queueIds,
  withUnreadMessages,
  whatsappIds,
  statusFilter,
  forceSearch,
  userFilter,
  sortTickets,
  searchOnMessages,
  filterType
}) => {
  const [loading, setLoading] = useState(true);
  const [hasMore, setHasMore] = useState(false);
  const [tickets, setTickets] = useState([]);
  const [count, setCount] = useState(0);

  // Reset count when search parameters change
  useEffect(() => {
    setCount(0);
  }, [searchParam, status, showAll, queueIds, userFilter, dateStart, dateEnd, whatsappIds, tags, users, statusFilter, searchOnMessages, filterType]);

  useEffect(() => {
    console.log("useTickets - forceSearch mudou:", { 
        forceSearch, 
        status, 
        timestamp: Date.now(),
        hookKey: `useTickets-${status}`
    });
    setLoading(true);
    const delayDebounceFn = setTimeout(() => {
      const fetchTickets = async () => {
        if (userFilter === undefined || userFilter === null) {
          try {
            
            const { data } = await api.get("/tickets", {
              params: {
                searchParam,
                pageNumber,
                tags,
                users,
                status,
                date,
                dateStart,
                dateEnd,
                updatedAt,
                showAll,
                queueIds,
                withUnreadMessages,
                whatsapps: whatsappIds,
                statusFilter,
                sortTickets,
                searchOnMessages,
                filterType
              },
            });

            let tickets = [];
            tickets = data.tickets;
            setTickets(tickets);
            setHasMore(data.hasMore);
            setCount(data.count)
            setLoading(false);
          } catch (err) {
            setLoading(false);
            toastError(err);
          }
        } else {
          try {
            const {data} = await api.get("/dashboard/moments", {
              params: {
                status,
                showAll,
                queueIds,
                dateStart: format(sub(new Date(), { days: 30 }), 'yyyy-MM-dd'),
                dateEnd: format(new Date(), 'yyyy-MM-dd'),
                userId: userFilter
              }
            })

            // console.log(data)
            let tickets = [];
            tickets = data.filter(item => item.userId === userFilter);

            setTickets(tickets);
            setHasMore(null);
            setCount(tickets.length); // Usar o comprimento dos tickets filtrados como count
            setLoading(false);
          } catch (err) {
            setLoading(false);
            toastError(err);
          }
        }
      };
      
      fetchTickets();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [
    searchParam,
    pageNumber,
    status,
    date,
    dateStart,
    dateEnd,
    updatedAt,
    showAll,
    queueIds,
    withUnreadMessages,
    whatsappIds,
    tags,
    users,
    statusFilter,
    searchOnMessages,
    forceSearch,
    sortTickets,
    filterType
  ]);

  // Forçar atualização quando o hook for re-montado
  useEffect(() => {
    console.log("useTickets - Hook re-montado:", { 
        status, 
        timestamp: Date.now(),
        hookKey: `useTickets-${status}`
    });
  }, []);

  return { tickets, loading, hasMore, count };
};

export default useTickets;
